import { Restaurant } from '../types'

export enum ReservationStatus {
  UPCOMING = 'UPCOMING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface IReservation {
  id: string
  reservationDate: string
  guests: number
  status: ReservationStatus
  cancelReason?: string
  time: string
  restaurant: Restaurant
}
